import type { Deployment, DiffPull, DiffResult } from "@rebuild/shared";
import { PrRow } from "./PrRow";
import { findDeploymentForPullInTimeline, getIncludedPullsForDeploy } from "../deployTarget";

export function DiffView({
  diff,
  loading,
  stagingHistory,
  onDeployTarget,
}: {
  diff: DiffResult | null;
  loading: boolean;
  stagingHistory: Deployment[];
  onDeployTarget: (pull: DiffPull, deployment: Deployment, includedPulls: DiffPull[]) => void;
}) {
  if (loading) {
    return <p className="text-sm text-gray-400 py-2">Loading changes...</p>;
  }

  if (diff?.error) {
    return <p className="text-sm text-red-600 py-2">{diff.error}</p>;
  }

  const warningBanner = diff?.warning ? (
    <p className="text-sm text-amber-600 py-1">{diff.warning}</p>
  ) : null;

  if (!diff?.pulls.length) {
    return (
      <div>
        {warningBanner}
        <p className="text-sm text-gray-400 py-2">
          {diff?.commits ?? 0} commit{diff?.commits !== 1 ? "s" : ""} ahead, no merged PRs found.
        </p>
      </div>
    );
  }

  const sorted = [...diff.pulls].reverse();

  return (
    <div className="space-y-1.5">
      {warningBanner}
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-gray-400">
            {diff.ahead} commit{diff.ahead !== 1 ? "s" : ""} ahead &middot; {diff.pulls.length} PR{diff.pulls.length !== 1 ? "s" : ""}
          </p>
          <p className="text-xs text-gray-500 mt-0.5">
            Deploying a row includes that row and every older row below it.
          </p>
        </div>
        <span className="text-xs text-gray-400">Newest first</span>
      </div>
      {sorted.map((pr, index) => {
        const deployment = findDeploymentForPullInTimeline(pr, sorted, stagingHistory, index);
        return (
          <PrRow
            key={pr.number}
            pr={pr}
            deployment={deployment}
            onDeploy={() => deployment && onDeployTarget(pr, deployment, getIncludedPullsForDeploy(sorted, index))}
          />
        );
      })}
    </div>
  );
}
